import script from "./TriadTunerBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TriadTunerBar.vue?vue&type=script&setup=true&lang=js"

import "./TriadTunerBar.vue?vue&type=style&index=0&id=2b786044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b786044"]])

export default __exports__